import { useQuery } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";
export const useTaxPreferences = () => {
  // get auth0 user details
  const { getToken } = useAuth();

  const fetchTaxPreferences = async (): Promise<Record<string, any>> => {
    const token = await getToken();

    const { data } = await authorizedAxios(token).get("/preferences/tax");
    return data;
  };
  const {
    data: taxPreferences,
    error: fetchError,
    isLoading: isFetching,
    refetch
  } = useQuery<Record<string, any>, Error>({
    queryKey: ["taxPreferences"],
    queryFn: fetchTaxPreferences,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
  return {
    data: taxPreferences,
    isLoading: isFetching,
    error: fetchError,
    refetch
  };
};
